import { atom } from 'recoil';

// 解約受付API用の集荷先住所データ構造
export type CollectionAddressForAPI = {
  collection_zip_code: string;
  collection_prefecture: string;
  collection_city: string;
  collection_town: string;
  collection_optional: string;
  collection_tel: string;
};

// API送信用の集荷先住所データの状態管理
const collectionAddressForAPIState = atom<CollectionAddressForAPI>({
  key: 'collectionAddressForAPIState',
  default: {
    collection_zip_code: '',
    collection_prefecture: '',
    collection_city: '',
    collection_town: '',
    collection_optional: '',
    collection_tel: '',
  },
});

export default collectionAddressForAPIState;
